import { render, staticRenderFns } from "./Methodics.vue?vue&type=template&id=55f4ae9c"
import script from "./Methodics.vue?vue&type=script&lang=js"
export * from "./Methodics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports